import { mapNamesToSubtestIds, activitiesByItemId, } from "./"
import forOwn from 'mout/object/forOwn'

/**
 * Compute scoring and add it to the userAssessment
 * @param {object} uA the userAssessment, which has data on student performance on a test
 * @returns {object} userAssessment with scoring added
 */
export default function addScoring (uA) {
  const subtestIds = mapNamesToSubtestIds(uA)
  const subjects = ['English', 'Math', 'Reading', 'Science']
  
  // score by item
  function computeScoreByItem(uA, subtestId) {
    const activities = activitiesByItemId(uA.activity[subtestId])
    let byItem = {...uA.scoring.byItem[subtestId]}
    forOwn({...byItem}, (val, key) => {
      const raw = activities[key].grade
      byItem[key].raw = raw
      byItem[key].complete = true
    })
    return byItem
  }

  // call computeScoreByItem for each subtest
  let byItem = {}
  subjects.forEach(subject => {
    const subtestId = subtestIds[subject]
    byItem[subtestId] = computeScoreByItem(uA, subtestId)
  })
  

  // score by subtest
  function computeSubtestScore(uA, subtestId) {
    const activities = Object.values(uA.activity[subtestId])
    let raw = 0
    const possible = activities.length
    activities.forEach(activity => raw += activity.grade)
    const { rawToScaleScoring } = uA.assessmentSubtests[subtestId]
    const scale = Number(rawToScaleScoring[raw])
    return {
      complete: true,
      percentage: raw / possible,
      possible,
      raw,
      scale,
    }
  }

  // call computeSubtestScore for each subtest
  let bySubtest = {}
  subjects.forEach(subject => {
    const subtestId = subtestIds[subject]
    bySubtest[subtestId] = computeSubtestScore(uA, subtestId)
  })


  // score by node
  function computeScoreByNode (uA, subtestId) {
    const activities = activitiesByItemId(uA.activity[subtestId])
    let byNode = {...uA.scoring.byNode[subtestId]}
    forOwn({...byNode}, (val, key) => {
      const { possible, items, } = val
      let raw = 0
      items.forEach(item => {
        raw += activities[item].grade
      })
      const percentage = raw / possible
      byNode[key].raw = raw
      byNode[key].percentage = percentage
    })
    return byNode
  }

  // call somputeScoreByNode for each subtest
  let byNode = {}
  subjects.forEach(subject => {
    const subtestId = subtestIds[subject]
    byNode[subtestId] = computeScoreByNode(uA, subtestId)
  })

  // score by test
  function computeScoreByTest (bySubtest) {
    const subtestScores = Object.values(bySubtest)
    let raw = 0, possible = 0, scaleSum = 0
    const subtestCount = subtestScores.length
    subtestScores.forEach(score => {
      raw += score.raw
      possible += score.possible
      scaleSum += score.scale
    })
    const scale = Math.round(scaleSum / subtestCount)
    const percentage = raw / possible
    return {
      raw,
      possible,
      percentage,
      scale,
      complete: true,
    }
  }

  const byTest = computeScoreByTest(bySubtest)
  
  // return the uA with scoring information added
  return {
    ...uA,
    scoring: {
      byItem,
      byNode,
      bySubtest,
      byTest,
    }
  }
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/uploadCSV/addScoring.js